import { changeTextLineIDsObjectForApi } from "./apiUtils";

export async function getPageDataApi(pageID) {
  const uri = process.env.REACT_APP_API_ROOT + "pages/" + pageID;

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  data.words.map((aWord, idx) => {
    aWord.index = idx;
    return aWord;
  });

  return data;
}

export async function getPageTagApi(pageID) {
  const uri = `${process.env.REACT_APP_API_ROOT}pages/${pageID}/word_tags`;

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function pageTagApi(pageID, wordIdx) {
  const uri = `${process.env.REACT_APP_API_ROOT}pages/${pageID}/word_tags`;

  const body = {
    tag: "heading",
    word_indices: wordIdx,
    page_id: pageID
  };

  const response = await fetch(uri, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function deleteTagApi(tagID) {
  const uri = `${process.env.REACT_APP_API_ROOT}word_tags/${tagID}`;

  const response = await fetch(uri, {
    method: "DELETE"
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function mergePageTextLineApi(issueID, textLineIDs) {
  if (issueID == null || issueID === "") {
    throw Error("issue id empty");
  }

  const uri = `${
    process.env.REACT_APP_API_ROOT
  }pdf_books/${issueID}/paragraphs`;

  const body = {
    text_line_ids: changeTextLineIDsObjectForApi(textLineIDs)
  };

  const response = await fetch(uri, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  data.result = data.result.trim();

  return data;
}

export async function flattenApi(pageID) {
  const uri = process.env.REACT_APP_API_ROOT + "pages/" + pageID + "/flatten";

  let response = await fetch(uri, {
    method: "POST"
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function getPageImagesApi(pageID) {
  const uri = process.env.REACT_APP_API_ROOT + "pages/" + pageID + "/images";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function getPagePageImageApi(pageID) {
  const uri =
    process.env.REACT_APP_API_ROOT + "pages/" + pageID + "/page_artwork";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function getPageImagesScreenshot(pageID, x, y, width, height) {
  const uri = `${
    process.env.REACT_APP_API_ROOT
  }pages/${pageID}/screenshot?x=${x}&y=${y}&w=${width}&h=${height}`;

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function addPageImagesScreenshot(pageID, x, y, width, height) {
  const uri = `${process.env.REACT_APP_API_ROOT}pages/${pageID}/screenshot`;

  const body = {
    x: x,
    y: y,
    w: width,
    h: height
  };

  const response = await fetch(uri, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function addPageImageApi(pageID, imageFile, imageUrl) {
  const uri = process.env.REACT_APP_API_ROOT + "pages/" + pageID + "/images";

  var formData = new FormData();

  if (imageFile != null) {
    formData.append("image", imageFile);
  } else if (imageUrl != null) {
    formData.append("url", imageUrl);
  } else {
    throw Error("no input image");
  }

  let response = await fetch(uri, {
    method: "POST",
    body: formData
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function addPageImageRotate(pageID, imageID, degree) {
  const uri = `${process.env.REACT_APP_API_ROOT}pages/${pageID}/rotate`;

  const body = {
    artwork_id: imageID,
    degrees: degree
  };

  const response = await fetch(uri, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function combineImage(pageID, leftImageID, rightImageID) {
  const uri = `${
    process.env.REACT_APP_API_ROOT
  }pages/${pageID}/combine?left_artwork_id=${leftImageID}&right_artwork_id=${rightImageID}`;

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function cropImageApi(pageID, imageFile) {
  const uri = process.env.REACT_APP_API_ROOT + "pages/" + pageID + "/crop";
  var formData = new FormData();

  if (imageFile != null) {
    formData.append("image", imageFile);
  } else {
    throw Error("no input image");
  }

  let response = await fetch(uri, {
    method: "POST",
    body: formData
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}
